import type { ComponentPropsWithRef } from "react";
import React from "react";

type PropType = ComponentPropsWithRef<"button">;

export const DotButton: React.FC<PropType> = ({ children, ...restProps }) => {
  return (
    <button type="button" {...restProps}>
      {children}
    </button>
  );
};
